import { render } from "./EmailAccount.vue?vue&type=template&id=3d96b0b6&scoped=true"
import script from "./EmailAccount.vue?vue&type=script&lang=js"
export * from "./EmailAccount.vue?vue&type=script&lang=js"

import "./EmailAccount.vue?vue&type=style&index=0&id=3d96b0b6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d96b0b6"]])

export default __exports__